// Custom Video Play
export function videoPlay() {
  [...document.querySelectorAll('.wp-block-video')]?.forEach( video => {
      const videoItem = video.querySelector('video:not([controls])');

      if (videoItem) {
        videoItem.parentElement.classList.add('no-controls');
      }

      videoItem.addEventListener ('play', function() {
          videoItem.play();

          if (videoItem.ended) {
            video.classList.remove('wp-block-video--play');
          }
        }, 
        false
      );
    
      videoItem.onclick = function() {
        if (videoItem.paused) {
          video.classList.add('wp-block-video--play');
          videoItem.play();
        } else {
          video.classList.remove('wp-block-video--play');
          videoItem.pause();
        }
        return false;
      };

      videoItem.addEventListener("ended", (event) => {
        video.classList.remove('wp-block-video--play');
      });
  })
}